import apiCore from '../../utils/api-core';

export function getMessageStatuses() {
	return apiCore.get('/api/v1/message-statuses');
}